import { useState, useEffect } from 'react';

//Breadcrumb
import IntentDrawer from '../../Common/IntentDrawer'
import Breadcrumb from '../../Common/Breadcrumb';
import IntentsTable from '../../Common/IntentsTable'
import ConfirmModal from '../../Common/ConfirmModal';
import IntentAggregations from '../../Common/IntentAggregations'
import { APIClient } from "../../helpers/api_helper";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { Button, Card, Col, Space, Tooltip } from 'antd';
import {PlusOutlined, DeleteOutlined, EditOutlined, DownloadOutlined} from '@ant-design/icons';
import { setFilterData, setInitialFilterConf, updateFilterData } from '../../slices/filters/thunk'
import utils from '../../Common/utils';


const api = new APIClient();


const Intents = () => {
  document.title = "Transakcije" + process.env.REACT_APP_PAGE_TITLE;

  const dispatch = useDispatch();
  const filterdata = useSelector((state) => state.Filterdata.data)
  const [intentsData, setIntentsData] = useState([{'results': []}]);
  const [intentAggsData, setIntentAggsData] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const [open, setOpen] = useState(false);
  const [massEditOpen, setMassEditOpen] = useState(false);
  const [showDeletionConfirmModal, setShowDeletionConfirmModal] = useState(false);
  const [editedIntentId, setEditedIntentId] = useState(null);
  const [exportLoading, setExportLoading] = useState(false);
  const [loading, setLoading] = useState(false);



  const loadIntentsData = () => {
    const filterdata = utils.getObjectFromURL()

    setLoading(true);
    api.get('/api/intents/', filterdata)
      .then(resp => setIntentsData(resp))
      .finally(() => setLoading(false));
    api.get('/api/insights/current_income_expense_sums/', filterdata).then(resp => {
      setIntentAggsData(resp)
    })
  }

  const handleExport = () => {
    const params = utils.cleanEmpty(
      selectedIds.length > 0
        ? { ids: selectedIds.join(',') }
        : utils.getObjectFromURL()
    );
    setExportLoading(true);
    axios.get(`/api/intents/export_xlsx/`, { params, responseType: 'blob' })
      .then(blob => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'intents.xlsx';
        a.click();
        URL.revokeObjectURL(url);
      })
      .finally(() => setExportLoading(false));
  }

  const handleConfirmedDelete = () => {
    api.delete(`/api/intents/delete_bulk/`, {'ids': selectedIds}, {successMsg: `Uspešno izbrisanih ${selectedIds.length} transakcij`})  // keep 'data', server will handle it diferently than POST!
      .then(resp => {
        setShowDeletionConfirmModal(false);
        loadIntentsData()
      })
      .catch(error => {
        console.error(error)
      })
  }


  useEffect(() => {
    dispatch(setInitialFilterConf({
      data: {
        'date_range': utils.getCurrentYearMonth(),
        'hidden': [],
        'disabled': []
      },
      masterSearch: true,
    }))
    dispatch(setFilterData(utils.getObjectFromURL()))
  }, []);


  useEffect(() => {
    loadIntentsData()
  }, [filterdata]);


  return (
    <>
      <Breadcrumb parentTitle="" pageTitle={utils.getObjectFromURL().override_page_title || "Transakcije"} />

      <IntentAggregations data={intentAggsData} />

      <IntentDrawer
        open={open}
        onCancel={() => {
          setOpen(false);
          setEditedIntentId(null);
        }}
        onDone={() => {
          loadIntentsData(filterdata);
          setEditedIntentId(null);
          setOpen(false);
        }}
        onIntentChanged={() => loadIntentsData(filterdata)}
        onOpenIntent={(id) => {
          setEditedIntentId(id);
          setOpen(true);
        }}
        editedIntentId={editedIntentId}
      />

      <IntentDrawer
        open={massEditOpen}
        massEdit={true}
        massEditIds={selectedIds}
        onCancel={() => setMassEditOpen(false)}
        onDone={() => {
          loadIntentsData(filterdata);
          setMassEditOpen(false);
        }}
        editedIntentId={null}
      />

      <>
        <Col xs={24} className="gutter-row">

          <Card
            title='Seznam transakcij'
            extra={
              <Space>
                <Tooltip title="Množično urejanje">
                  <Button
                    disabled={selectedIds.length == 0}
                    onClick={() => setMassEditOpen(true)}
                    icon={<EditOutlined />}
                  />
                </Tooltip>
                <Tooltip title="Izbriši izbrane">
                  <Button
                    disabled={selectedIds.length == 0}
                    onClick={ev => {
                      setShowDeletionConfirmModal(true);
                    }}
                    icon={<DeleteOutlined />}
                  />
                </Tooltip>
                <Tooltip title="Izvozi v Excel">
                  <Button
                    loading={exportLoading}
                    disabled={exportLoading}
                    onClick={handleExport}
                    icon={<DownloadOutlined />}
                  />
                </Tooltip>
                <Tooltip title="Dodaj transakcijo">
                  <Button
                    onClick={ev => {
                      setEditedIntentId(null)
                      setOpen(true)
                    }}
                    icon={<PlusOutlined />}
                  />
                </Tooltip>
              </Space>
            }
          >
              <IntentsTable
                page={filterdata.page}
                loading={loading}
                intentsData={intentsData}
                onPageChange={pInx => dispatch(updateFilterData({page: pInx}))}
                selectedIds={selectedIds}
                setSelectedIds={setSelectedIds}
                onIntentEdit={r => {
                  setEditedIntentId(r.id)
                  setOpen(true);
                }}
                onIntentChanged={() => loadIntentsData()}
              />
            </Card>
        </Col>
        <ConfirmModal
          textComponent={<p>{`Ali ste prepričani, da želite izbrisati ${selectedIds.length} transakcij?`}</p>}
          open={showDeletionConfirmModal}
          confirmBtnTitle='Izbriši'
          confirmBtnProps={{'danger': true}}
          onOk={() => handleConfirmedDelete()}
          onCancel={() => {
            setShowDeletionConfirmModal(false);
          }}
        />

      </>
    </>
  )
}

export default Intents;
